'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/es-errors/index.js
// module id = ../../../../es-errors/index.js
// module chunks = 5